import Vue from 'vue';
import Vuex from 'vuex';
import { MelosPlayerStatus } from '@/components/MelosPlayer.vue';
import { MelosTrack, MelosStation, MelosDevice, MelosPodcast } from '@/services/api.service';

Vue.use(Vuex);

export interface SessionData {
  token: string;
  refreshToken: string;
  username: string;
  userId: string;
  expirationDate?: Date;
  version: number;
}

export interface PlayerData {
  audioSource: string | undefined;
  trackDuration: number;
  targetElapsedTime: number;
  trackTitle: string;
  targetStatus: MelosPlayerStatus;
  currentStatus: MelosPlayerStatus;
  currentElapsedTime: number;
  waveformContent?: string;
  stationId?: string;
  provider?: string;
  link?: string;
  author?: string;
  imageSrc?: string;
  loop: boolean;
  volume?: number;
}

export enum SessionMetadata {
  VERSION = 1,
}

const defaultSessionData: SessionData = {
  token: '',
  refreshToken: '',
  username: '',
  userId: '',
  expirationDate: new Date(),
  version: SessionMetadata.VERSION,
};

const defaultPlayerData: PlayerData = {
  audioSource: undefined,
  trackDuration: 0,
  targetElapsedTime: 0,
  trackTitle: '',
  targetStatus: MelosPlayerStatus.STOPPED,
  currentStatus: MelosPlayerStatus.STOPPED,
  currentElapsedTime: 0,
  provider: undefined,
  link: undefined,
  loop: false,
};

export default new Vuex.Store({
  state: {
    session: defaultSessionData,
    connectedDevice: undefined,
    player: defaultPlayerData,
    melosStations: [],
    deviceStations: [],
    windowData: {
      width: 0,
      height: 0,
    },
    checkedItems: [],
    interfaceData: {
      showLargeInterface: false,
    },
    ownedTracks: [],
    ownedStations: [],
    ownedDevices: [],
    ownedPodcasts: [],
    uriTime: new Date().getTime(),
    stationUriTime: new Date().getTime(),
  },
  mutations: {
    refreshOwnedStations: (state: any) => {
      state.stationUriTime = new Date().getTime();
    },
    setDeviceStations: (state: any, deviceStations) => {
      state.deviceStations = deviceStations;
    },
    setConnectedDevice: (state: any, deviceId: string) => {
      state.connectedDevice = deviceId;
    },
    setCheckedItems: (state: any, data: string[]) => {
      state.checkedItems = data;
    },
    setInterfaceData: (state: any, data: any) => {
      state.interfaceData = data;
    },
    setWindowData: (state: any, data: any) => {
      state.windowData = data;
    },
    setSessionData: (state: any, data: any) => {
      state.session = data;
    },
    clearSessionData: (state: any, data: any) => {
      state.session = defaultSessionData;
      state.ownedTracks = [];
      state.ownedPodcasts = [];
      state.ownedStations = [];
      state.tracks = [];
      state.melosStations = [];
    },
    setToken: (state: any, token: string) => {
      state.session.token = token;
    },
    setPlayerData: (state: any, playerData) => {
      state.player = { ...state.player, ...playerData };
    },
    setStations: (state: any, stationList) => {
      state.melosStations = stationList;
    },
    setOwnedTracks: (state: any, tracks: MelosTrack[]) => {
      state.ownedTracks = tracks;
      state.uriTime = new Date().getTime();
    },
    setOwnedStations: (state: any, stations: MelosStation[]) => {
      state.ownedStations = stations;
      state.uriTime = new Date().getTime();
    },
    setOwnedDevices: (state: any, devices: MelosDevice[]) => {
      state.ownedDevices = devices;
    },
    setOwnedPodcasts: (state: any, podcasts: MelosPodcast[]) => {
      state.ownedPodcasts = podcasts;
    },
  },
  actions: {

  },
});
